














import Vue from 'vue'
import { CheckboxElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'CheckboxEl',

  data: () => ({
    checked: false
  }),

  mounted () {
    if (typeof this.templateItemData.value !== 'undefined') {
      this.checked = this.templateItemData.value
    }
  },

  props: {
    templateItemData: {
      type: Object as () => CheckboxElInterface,
      required: true
    }
  }
})
